<template>
  <div class="wrap-box">
    <div class="view-title">
      <p class="title">
        {{ words.Printlist }}
        <Tooltip content="待打订单保留15天过期自动清除!">
          <Icon type="ios-alert" size="20" />
        </Tooltip>
      </p>
      <div class="btn-box">
        <Button size="large" class="primary" type="primary" @click="AddFileShow">
          {{ words.AddFiles }}
          <Icon type="md-add" />
        </Button>
      </div>
    </div>
    <div class="table-box">
      <Table size="large" :row-class-name="rowClassName" :columns="columns" stripe :data="data" :height="700"
        :loading="loading"></Table>
    </div>
    <div class="t-right">
      <Page @on-change="pageChange" @on-page-size-change="sizeChange" :total="total" />
    </div>

    <Modal v-model="AddFileModel" title=" " :width="988" :footer-hide="true">
      <div class="add-file-box">
        <input type="file" class="input" @change="ChangeInput($event)" multiple="multiple" />
        <!--  accept="image/jpeg, image/png, image/jpg, text/csv, image/tiff, text/plain, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.ms-excel.addin.macroEnabled.12" -->
        <div class="add-file-icon" :class="{ addFileIconStatus: draging }" ref="cropper">
          <img :src="addFIleIcon" alt class="icon" />
        </div>
        <div class="add-file-bottom">
          <p class="btn">{{ words.AddFiles }}</p>
          <p class="tips">{{ words.DragAndDropFilesToThisAreaToUpload }}</p>
        </div>
      </div>
    </Modal>

    <Modal v-model="UploadModel" title=" " :width="988" @on-ok="UploadFileOk" @on-cancel="UploadFileCancel"
      :footer-hide="true" :mask-closable="false">
      <div class="upload-file-box">
        <div class="item-box">
          <div class="item" v-for="(item, key) in files" :key="key" :class="{ up: item.progress }">
            <div class="file-name">{{ item.name }}</div>
            <div class="size item-child">{{ item.show_size }}</div>
            <div class="status item-child">
              {{
                  item.status === 0
                    ? words.Waiting
                    : item.status === 1
                      ? words.Uploading + item.progress + "%"
                      : item.status === 2
                        ? words.Success
                        : item.status === 3
                          ? "上传失败"
                          : "异常"
              }}
            </div>
            <div class="del" @click="delFile(key)">{{ words.Delete }}</div>
            <div class="progress" v-if="item.status > 0" :style="{ width: item.progress + '%' }"></div>
          </div>
        </div>
        <div class="btn-box">
          <input type="file" class="input" id="uploadBtn" ref="uploadBtn" @change="ChangeInput($event)"
            multiple="multiple" v-show="false" />
          <p class="btn add" @click="UploadFileAddChange">
            {{ words.PRINT_AddFiles }}
          </p>
          <p class="btn upload" :class="{ uploadStatus: files.length }" @click="uploadSubmit">
            {{ words.Upload }}
          </p>
        </div>
      </div>
    </Modal>

    <Modal v-model="CloseTips" draggable scrollable title="提醒" :mask-closable="false" @on-ok="closeUpload(2)"
      @on-cancel="closeUpload(1)">
      <div style="text-align: center; padding: 15px">是否中断上传</div>
    </Modal>
  </div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";
import { setInterval, clearInterval, setTimeout } from "timers";

export default {
  components: {},
  data() {
    return {
      loading: false,
      columns: [
        /* {
          title: "文件名",
          key: "file_real_name",
          width: 240,
          className: "table-header-col"
        },
        {
          title: "大小",
          key: "file_size",
          className: "table-header-col"
        },
        {
          title: "页数",
          key: "pages",
          className: "table-header-col"
        },
        {
          title: "提交方式",
          key: "mode",
          className: "table-header-col",
          render: (h, data) => {
            return h("span", "文件上传");
          }
        },
        {
          title: "文件状态",
          key: "pages",
          className: "table-header-col",
          render: (h, data) => {
            return h(
              "span",
              {
                style: {
                  color:
                    data.row.file_status === 0 || data.row.file_status === 1
                      ? "#ff9900"
                      : data.row.file_status === 2
                      ? "#19be6b"
                      : data.row.file_status === 3
                      ? "#ed4014"
                      : "#ed4014"
                }
              },
              data.row.file_status === 0 || data.row.file_status === 1
                ? "转换中"
                : data.row.file_status === 2
                ? "转换完成"
                : data.row.file_status === 3
                ? "转换失败"
                : "已删除"
            );
          }
        },
        {
          title: "提交时间",
          key: "create_time",
          className: "table-header-col",
          render: (h, data) => {
            return h("span", this.$moment(new Date(data.row.create_time)));
          },
          width: 200
        },
        {
          title: "操作",
          key: "oper",
          className: "table-header-col",
          render: (h, data) => {
            return h("div", {}, [
              h(
                "Button",
                {
                  props: {
                    type: "success"
                  },
                  on: {
                    click: () => {
                      this.down(data.row);
                    }
                  }
                },
                "下载"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error"
                  },
                  on: {
                    click: e => {
                      this.del(data.row._index, data.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        } */
      ],
      data: [],
      page: {
        p: 0,
        l: 10,
        is_pc: 1,
        type: 1,
      },
      total: 0,

      //文件
      AddFileModel: false,
      addFIleIcon: require("../../assets/add-file.png"),
      draging: false,
      files: [],
      //上传
      UploadModel: false,
      SubmitStatus: false,
      UploadSuccess: 0,
      ProgressTimer: [],

      CloseTips: false,
      //文件状态，计时器
      Timer: 0,
    };
  },
  mounted() {
    this.columns = [
      {
        title: this.words.FilName,
        key: "file_real_name",
        width: 240,
        className: "table-header-col",
      },
      {
        title: this.words.PrintSize,
        key: "file_size",
        className: "table-header-col",
      },
      {
        title: this.words.PrintPage,
        key: "pages",
        className: "table-header-col",
      },
      {
        title: this.words.Mode,
        key: "mode",
        className: "table-header-col",
        render: (h, data) => {
          return h(
            "span",
            data.row.upload_type
              ? this.words.Print_file_drive
              : this.words.Print_file_upload
          );
        },
      },
      {
        title: this.words.FileStatus,
        key: "pages",
        className: "table-header-col",
        render: (h, data) => {
          return h(
            "span",
            {
              style: {
                color:
                  data.row.file_status === 0 || data.row.file_status === 1
                    ? "#ff9900"
                    : data.row.file_status === 2
                      ? "#19be6b"
                      : data.row.file_status === 3
                        ? "#ed4014"
                        : "#ed4014",
              },
            },
            data.row.file_status === 0 || data.row.file_status === 1
              ? this.words.InConversion
              : data.row.file_status === 2
                ? this.words.WaitingForPrinting
                : data.row.file_status === 3
                  ? this.words.ConversionFailed
                  : this.words.Delete
          );
        },
      },
      {
        title: this.words.PrintDate,
        key: "create_time",
        className: "table-header-col",
        render: (h, data) => {
          return h("span", this.$moment(new Date(data.row.create_time)));
        },
        width: 200,
      },
      {
        title: '打印码',
        key: "pin_code",
        className: "table-header-col",
        width: 100,
        render: (h, data) => {
          if (data.row.pin_code) {
            return h("span", data.row.pin_code);
          } else if(data.row.file_status === 2){
            return h(
              "p",
              {
                style: {
                  color: "#2d8cf0",
                  cursor:"pointer"
                },
                props: {
                  type: "text",
                },
                on: {
                  click: () => {
                    this.GetJobPinCode({ id: data.row.id }).then(res => {
                      this.getList();
                    });
                  },
                },
              },
              '获取'
            )
          }
        },
        width: 200,
      },
      {
        title: this.words.Operate,
        key: "oper",
        className: "table-header-col",
        width: 200,
        render: (h, data) => {
          return h("div", {}, [
            h(
              "Button",
              {
                props: {
                  type: "success",
                },
                on: {
                  click: () => {
                    if (data.row.file_status !== 2) {
                      this.$Message.error("转换不成功的文件不可预览");
                      return false;
                    }
                    this.down(data.row);
                  },
                },
              },
              this.words.Preview
            ),
            h(
              "Button",
              {
                props: {
                  type: "error",
                },
                on: {
                  click: (e) => {
                    this.del(data.row._index, data.row.id);
                  },
                },
              },
              this.words.Delete
            ),
          ]);
        },
      },
    ];
    this.getList();
  },
  methods: {
    rowClassName(row, index) {
      if (index === 1) {
        return "demo-table-info-row";
      } else if (index === 3) {
        return "demo-table-error-row";
      }
      return "";
    },
    ...mapActions([
      "UploadJobFile",
      "GetJobList",
      "FilePre",
      "DelJob",
      "GetJoibStatus",
      "GetJobPinCode"
    ]),
    //显示添加文件model
    AddFileShow() {
      this.bindCropper();
      this.AddFileModel = true;
      this.UploadModel = false;
      this.$refs.uploadBtn.value = "";
    },
    UploadFileAddChange() {
      this.$refs.uploadBtn.click();
    },
    //取消添加
    UploadFileCancel() {
      // this.AddFileModel = false;
      this.CloseTips = true;
    },
    closeUpload(e) {
      if (e == 1) {
        this.CloseTips = false;
      }
      if (e == 2) {
        this.files = [];
        this.AddFileModel = false;
        this.CloseTips = false;
      }
    },
    //确认添加文件
    UploadFileOk() { },
    //拖拽
    bindCropper() {
      this.$refs.cropper.addEventListener(
        "dragover",
        (e) => {
          e.preventDefault();
          if (!this.draging) {
            this.draging = true;
          }
        },
        false
      );
      this.$refs.cropper.addEventListener(
        "dragleave",
        (e) => {
          e.preventDefault();
          if (this.draging) {
            this.draging = false;
          }
        },
        false
      );

      this.$refs.cropper.addEventListener(
        "drop",
        (e) => {
          e.preventDefault();
          this.draging = false;
          let files = e.dataTransfer.files;
          for (var i = 0; i < files.length; i++) {
            this.formatFiles(files[i]);
          }
          this.AddFileModel = false;
          this.UploadModel = true;
        },
        false
      );
    },
    // 格式化文件
    formatFiles(file) {
      let Suffix = file.name.split(".")[file.name.split(".").length - 1];
      if (this.$lfy.IsSupportFile(Suffix)) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (res) => {
          let size = file.size / 1024;
          /*  if (size > 1024) item.file_size = (size / 1024).toFixed(2) + "MB";
          else item.file_size = size.toFixed(2) + "KB"; */
          this.files.push({
            file: file,
            blob: res.target.result,
            name: file.name,
            size: file.size,
            show_size:
              size > 1024
                ? (size / 1024).toFixed(2) + "MB"
                : size.toFixed(2) + "KB",
            progress: 0,
            status: 0,
          });
          this.$refs.uploadBtn.value = "";
        };
      }
    },
    ChangeInput(e) {
      for (var i = 0; i < e.target.files.length; i++) {
        this.formatFiles(e.target.files[i]);
      }
      this.AddFileModel = false;
      this.UploadModel = true;
      this.$refs.uploadBtn.value = "";
      e.target.value = '';
    },
    delFile(index) {
      this.files.splice(index, 1);
      if (this.files.length < 1) {
        this.UploadModel = false;
        this.AddFileModel = true;
      }
    },
    pageChange(e) {
      this.page.p = e - 1;
      this.getList();
    },
    sizeChange(e) {
      this.page.p = p - 1;
      this.getList();
    },
    getList() {
      this.loading = true;
      this.GetJobList(this.page).then((res) => {
        let timerData = [];
        res.data.map((item, index) => {
          if (item.file_status === 0 || item.file_status === 1) {
            //文件还没转换完成，定时请求文件状态
            timerData.push(item);
          }
          let size = item.file_size / 1024;
          if (size > 1024) item.file_size = (size / 1024).toFixed(2) + "MB";
          else item.file_size = size.toFixed(2) + "KB";
        });
        this.loading = false;
        this.data = res.data;
        this.total = res.total;
        clearInterval(this.Timer);
        if (timerData.length) this.TimerFun(timerData);
      });
    },
    async TimerFun(timerData) {
      if (!timerData.length) return false;
      this.Timer = setInterval(() => {
        console.log(493, timerData);
        let temp_ids = [];
        timerData.map((item) => {
          if (item.file_status <= 1) {
            temp_ids.push(item.id);
          }
        });
        if (temp_ids.length < 1) {
          clearInterval(this.Timer);
          return false;
        }
        this.GetJoibStatus({ id: temp_ids.join(",") }).then((res) => {
          res.map((r) => {
            if (r.file_status > 1) {
              this.data.map((d, i) => {
                if (r.id === d.id) {
                  d.file_status = r.file_status;
                  d.pages = r.pages;
                  d.file_path = r.file_path;
                  timerData.splice(i, 1);
                }
              });
            }
          });
        });
      }, 5000);
    },
    async uploadSubmit() {
      if (this.SubmitStatus) {
        return false;
      }

      let successNum = 0,
        SelfNum = 0;
      this.SubmitStatus = true;
      for (let i = 0; i < this.files.length; i++) {
        SelfNum = i + 1;
        if (this.files[i].status !== 0) {
          continue;
        }

        this.files[i].status = 1;
        let file_type =
          this.files[i].name.split(".")[
          this.files[i].name.split(".").length - 1
          ];
        let check = {
          user_id: this.user.id || "",
          file_type,
          file_size: this.files[i].size,
        };
        let checkResult = await this.FilePre(check);
        if (!checkResult.status) {
          //不支持该文件
          this.$Notice.warning({
            title: `上传失败`,
            desc: `“${this.files[i].name}”,${checkResult.msg}`,
            duration: 0,
          });
          this.files[i].status = 3;
          return false;
        }
        let data = {
          data: {
            userid: this.user.id || "",
            jobtype: 1,
            upload: this.files[i].file,
            checkDocument: checkResult.checkDocument,
          },
          baseUrl: checkResult.host,
        };

        //进度条
        let maxProgress = Math.floor(Math.random() * (75 - 90 + 1) + 90);
        this.ProgressTimer[i] = setInterval(() => {
          if (this.files[i].progress < maxProgress) {
            this.files[i].progress += Math.floor(
              Math.random() * (1 - 8 + 1) + 8
            );
          } else {
            clearInterval(this.ProgressTimer[i]);
          }
        }, 1000);
        this.UploadJobFile(data)
          .then((res) => {
            clearInterval(this.ProgressTimer[i]);
            if (!isNaN(parseInt(res)) && parseInt(res) > 0) {
              this.files[i].progress = 100;
              this.UploadSuccess++;
              this.files[i].status = 2;
              this.page = {
                p: 0,
                l: 10,
                is_pc: 1,
                type: 1,
              };
              if (this.UploadSuccess >= this.files.length) {
                this.$Notice.success({
                  title: "重要提示",
                  desc: `所有文件上传成功，等待文件转换完成，F5可刷新文件状态`,
                  duration: 2,
                });
                setTimeout(() => {
                  this.SubmitStatus = false;
                  this.UploadModel = false;
                  this.files = [];
                }, 2000);
              }
              this.getList();
            } else {
              this.files[i].status = 3;
              this.$Notice.warning({
                title: `上传失败`,
                desc: `“${this.files[i].name}”,失败原因：${res || "未知"
                  }，请等待其它文件上传`,
                duration: 0,
              });
            }
          })
          .catch((err) => {
            this.$Notice.warning({
              title: `上传失败`,
              desc: `“${this.files[i].name}”,失败原因：网络问题，请等待其它文件上传`,
              duration: 0,
            });
            this.files[i].status = 3;
          });
      }
    },
    del(index, id) {
      this.DelJob({ id }).then((res) => {
        if (res.code === 1) {
          this.getList();
        }
      });
    },
    down(item) {
      /* let path =
        "http://" +
        item.ip_address +
        ":8080/server_convert/FileOut/getFile?type=show&path=" +
        item.file_path; */
      if (
        !item.ip_address ||
        item.ip_address == "" ||
        item.ip_address == null ||
        !item.file_path
      ) {
        this.$Message.error("该文件不可下载");
        return false;
      }
      // path = path.replace(/\\/g,"/")
      let path =
        "http://" +
        item.ip_address +
        "/FileOut/getFile?type=show&path=" +
        item.file_path;
      window.open(path);
    },
  },
  computed: mapGetters({
    words: "words",
    user: "user",
  }),
  beforeDestroy() {
    clearInterval(this.Timer);
  },
};
</script>



<style lang="scss" >
@import "./index.scss";
</style>